import Tick from "@pqina/flip"

export default defineNuxtPlugin(nuxtApp => {
  return {
    provide: {
      tick: Tick
    }
  }
})
